
import { defineComponent, PropType } from "vue"
import User from "@/classes/auth/User"
import { RouteLocationRaw } from "vue-router"
export default defineComponent({
    name: "AvatarBadge",
    props: {
        user: {
            type: Object as PropType<User>,
            required: true
        },
        fallbackName: {
            type: String,
            required: false
        },
        showConfiguration: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    methods: {
        logout() {
            this.$store.dispatch('auth/logout')
            this.$router.push({
                name: 'login',
                query: {
                    message: 'auth/session-closed'
                }
            })
        },
        edit() {
            this.$router.push(
                {
                    name: 'profile-edit',
                    params: {
                        uid: this.user.uid
                    },
                    query: {
                        fallback: this.fallbackName || this.$route.name
                    }
                } as RouteLocationRaw
            )
        },
        settings() {
            this.$toast.error('Пока тут ничего нет')
        }
    },
    computed: {
        pageTitle() {
            return this.$route.meta.title
        },
        userInfo() {
            return this.$store.getters['auth/getUser']
        }
    }
})
